import React from 'react';
import { Portal } from './Portal';

const Modal = ({ children, isOpen, onClose, title = '' }) => {
    if (!isOpen) {
        return null;
    }
    
    return (
        <Portal>
            <div className="modal fade show" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{title}</h5>
                            <button type="button" onClick={onClose} style={{
                                backgroundColor: 'transparent',
                                borderWidth: 0,
                                fontFamily: 'inherit',
                                fontSize: 'inherit',
                                fontStyle: 'inherit',
                                fontWeight: 'inherit',
                                lineHeight: 'inherit',
                                padding: 0,
                                cursor: 'pointer',
                            }}>
                                <i className="fas fa-times" style={{ fontSize: '1.5rem' }}></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            {children}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dlg-primary pl-4 pr-4" onClick={onClose}>OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </Portal>
    );
};

export { Modal };